import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { getCustomerSatisfaction } from '@/service/dashboard';

const defaultState = {
  fetching: false,
  error: null,
  query: {},
  data: {}
}

export const fetchCustomerSatisfaction = createAsyncThunk(
  'customerSatisfaction/fetchCustomerSatisfaction',
  async ({query = {}}, {rejectWithValue}) => {
    try {
      const response = await getCustomerSatisfaction(query);
      return {
        data: response.data,
        query
      }
    } catch (error) {
      return rejectWithValue(error.response?.data || '获取客户满意度失败');
    }
  }
)

const customerSatisfactionSlice = createSlice({
  name: 'customerSatisfaction',
  initialState: defaultState,
  reducers: {
    resetCustomerSatisfactionState: (state, action) => {
        state.query = {};
        state.data = {};
      }
    },
    extraReducers: (builder) => {
      builder
        .addCase(fetchCustomerSatisfaction.pending, (state, action) => {
          state.fetching = true;
          state.error = null;
          state.query = action.meta.arg.query;
        })
        .addCase(fetchCustomerSatisfaction.fulfilled, (state, action) => {
          state.fetching = false;
          state.error = null;
          state.data = action.payload.data;
          state.query = action.payload.query;
        })
        .addCase(fetchCustomerSatisfaction.rejected, (state, action) => {
          state.fetching = false;
          state.error = action.payload;
          state.data = {};
        });
    }
})

export const { resetCustomerSatisfactionState } = customerSatisfactionSlice.actions;
export default customerSatisfactionSlice.reducer;